module.exports = __webpack_public_path__ + "static/media/OnBoarding_banor_tpOnboardingPengar.4679bd0e.png";